import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { Icon, Modal } from "antd";
import Cube from "../media/cubeload.gif";
import { urlPath } from "./Settings";
import { checkMaxFileSize, highlightMaterial } from "./Helpers";
import { getAuthHeader, handleErrors, hasPermission } from "../utils/security";

/*eslint no-loop-func: "off"*/
class AssetUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertModalContent: null,
      className: "ix-creative-dropzone ix-asset-dropzone",
      files: [],
      printAd: null,
      strings: this.props.language,
      tableData: [],
      translations: this.props.translations || {},
      uploadedFileCloudinaryUrl: ""
    };
    this.handleOk = this.handleOk.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    !this.isCancelled &&
      this.setState({
        strings: nextProps.language,
        translations: nextProps.translations
      });
  }

  handleDelete = () => {
    const { tableData, uploadFiles, selectedRowKeys } = this.state;
    console.log(uploadFiles);
    const uploadFilesTmpInit = uploadFiles;
    const uploadFilesTmpEnd = [];
    for (let value in selectedRowKeys)
      for (let file in tableData)
        if (tableData[file].key === selectedRowKeys[value]) {
          //uploadFiles.splice(file, 1);
          uploadFilesTmpEnd.push(uploadFilesTmpInit[file]);
        }
    this.setState({
      tableData: tableData,
      uploadFiles: uploadFilesTmpEnd
    });
  };

  onDrop(files, rejected, evt) {
    let items = evt.dataTransfer ? evt.dataTransfer.items : null;
    let reading = 0,
      reading2 = 0;
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];

    function scanFiles(entry) {
      console.log("Nested ", entry);
      reading2++;
      if (entry.isFile)
        entry.file(
          file => {
            file.fullPath = entry.fullPath;
            files.push(file);
            reading2--;
          },
          error => {
            console.error("Cannot convert to file", entry);
            reading2--;
          }
        );
      else {
        reading2--;
        let directoryReader = entry.createReader();
        directoryReader.readEntries(function(entries) {
          entries.forEach(entry => scanFiles(entry));
        });
      }
    }

    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const bytes = file.size;
      if (bytes === 0) {
        files.splice(index, 1);
        continue;
      }
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      file.formatSize =
        Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
      file.key = index;
      if (items && items[index].webkitGetAsEntry) {
        const item = items[index].webkitGetAsEntry();
        if (item && item.isDirectory) {
          files.splice(index, 1);
          reading++;
          item.createReader().readEntries(function(entries) {
            entries.forEach(function(entry) {
              scanFiles(entry);
            });
            reading--;
          });
        }
      }
    }
    const continueUpload = this.uploadFiles;
    if (reading === 0) continueUpload(files);
    else {
      function checkDone() {
        if (reading > 0 || reading2 > 0) window.setTimeout(checkDone, 100);
        else {
          if (files.length === 0) console.log("No files to upload");
          else continueUpload(files);
        }
      }
      checkDone();
    }
  }

  uploadFiles = files => {
    console.log("AssetsFinal", files);

    this.setState({
      tableData: files,
      uploadFiles: files,
      files
    });
    this.handleOk(files);
  };

  checkFileSize = files => {
    const { loadConfig } = this.props;
    let maxSize = loadConfig["web.uploadasset.maxsize"];
    maxSize = parseInt(maxSize, 10);
    for (let i = 0; i < files.length; i++) {
      const currentFile = files[i];
      const fileSize = currentFile.size / 1024 / 1024;
      console.log("maxSize", maxSize);
      console.log("fileSize", fileSize);
      if (fileSize > maxSize) {
        return false;
      }
    }
    return true;
  };

  handleOk = uploadFiles => {
    //this.setState({visible: true})
    const { loadConfig, translations } = this.props;
    let maxSize = loadConfig["web.uploadasset.maxsize"];
    const upload = checkMaxFileSize(uploadFiles, maxSize);
    if (upload) {
      const modal = Modal.info({
        title: this.state.translations.assetUpload,
        okButtonProps: { disabled: true },
        content: (
          <div className="text-center">
            <span data-translationkey="uploadingFiles" className="d-none">
              {this.state.translations.uploadingFiles}
            </span>
            <img className="loading-cube" src={Cube} alt="loading" />
          </div>
        ),
        footer: null
      });
      if (this.props.uploadingAssets) this.props.uploadingAssets();
      const matspecId = this.props.materialSpecificationId;
      const admaterialId = this.props.specId;
      const newAssetIds = [];
      const uploadFilesLength = uploadFiles.length;
      let uploadResponse = 0;
      this.props.unsubmittedChanges && this.props.unsubmittedChanges(true);
      for (let i = 0; i < uploadFiles.length; i++) {
        const formData = new FormData();
        formData.append("matspec", matspecId);
        formData.append("file", uploadFiles[i]);
        if (this.props.setAsVisual) {
          formData.append("type", "VISUAL");
        }
        fetch(urlPath + "/api/assetsave", {
          method: "POST",
          body: formData,
          credentials: "include",
          headers: getAuthHeader()
        })
          .then(handleErrors)
          .then(response => response.text())
          .then(response => {
            let assetId = response;
            /*/assetsave does not use JSON any more
                         if(assetId.includes('attach')){
                            assetId = JSON.parse(assetId);
                            assetId = assetId.attach;
                        }*/
            console.log(
              "Saved Asset." +
                assetId +
                " saved on MaterialSpecification." +
                matspecId
            );
            uploadResponse++;
            newAssetIds.push(assetId);
            //this.setState({visible: false})
            if (uploadResponse === uploadFilesLength) {
              if (this.props.setNewAssets)
                this.props.setNewAssets(
                  admaterialId ? admaterialId : null,
                  newAssetIds,
                  matspecId
                );
              if (this.props.loadAssets) {
                this.props.loadAssets();
              }
              if (this.props.setAsVisual) {
                this.props.reloadReport(true);
              }
              modal.destroy();
            }
          })
          .catch(e => {
            if (this.props.handleError) this.props.handleError();
            modal.destroy();
            console.error("Cannot save asset!", e);
          });
      }
    } else {
      Modal.error({
        title: "Error",
        content: translations.fileSizeExceeded + ": " + maxSize + " MB"
      });
    }
  };

  render() {
    const { strings } = this.state;
    let id = "drop-assets." + this.props.specId;
    return (
      <span className="asset-upload-root" data-id={this.props.specId}>
        <span id={id} className="assetUpload-dropzone-container">
          <div className="dropzone asset-dropzone">
            <form encType="multipart/form-data" action="">
              <Dropzone
                className={this.state.className}
                onDrop={this.onDrop.bind(this)}
                onDrop={this.onDrop.bind(this)}
                onClick={() => highlightMaterial(this.props.specId)}
              >
                <p
                  data-translationkey="dropVisual"
                  className="asset-upload-text"
                >
                  {this.props.translations
                    ? this.props.translations.dropVisual
                    : "Drop visual"}
                </p>
                <Icon type="upload" />
                <p
                  data-translationkey="dropAssets"
                  className="asset-upload-defaultText"
                >
                  {this.props.translations
                    ? this.props.translations.dropAssets
                    : "Drop Assets"}
                </p>
                <span className="drop-asset-label">
                  {this.props.dropAssets}
                </span>
              </Dropzone>
            </form>
          </div>
          <aside className="fileupload-aside d-none">
            <ul>
              {this.state.files.map(f => (
                <li key={f.name}>{f.name}</li>
              ))}
            </ul>
          </aside>
          <Modal
            translations={this.state.translations}
            selectedRowKeys={this.selectedRowKeys}
            modalTitle={strings ? strings.files : "files"}
            tableData={this.state.tableData}
            columns={this.state.columns}
            visible={this.state.visible}
            onOk={this.handleOk}
            onReturn={this.handleCancel}
            onCancel={() => console.log("none")}
            preview={this.state.preview}
            onDelete={this.handleDelete}
          />
        </span>
        <Modal title="Asset" visible={this.state.visible} footer={null}>
          <p data-translationkey="uploadingAssets" style={{ padding: "25px" }}>
            {this.props.translations
              ? this.props.translations.uploadingAssets
              : "Uploading assets..."}
          </p>
        </Modal>
      </span>
    );
  }

  componentDidMount() {
    if (this.props.status)
      hasPermission("com.ix.adp.model.Asset.create", this.props.status, val => {
        if (!val) {
          let elem = document.getElementById(
            "drop-assets." + this.props.specId
          );
          if (elem) elem.classList.add("v-hidden");
        }
      });
  }

  componentWillUnmount() {
    this.isCancelled = true;
  }
}

export default AssetUpload;



// WEBPACK FOOTER //
// ./src/components/AssetUpload.js